import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import moment, { Moment } from 'moment-timezone';

@Pipe({
  name: 'date'
})
export class DateTime implements PipeTransform {
  defaultFormat: string = "DD-MMM-YY hh:mm:ss A" // set the default format to DD-MMM-YY hh:mm:ss A
  
  transform(value: any, format: string = this.defaultFormat): any {
    return moment.tz(value, moment.tz.guess()).format(format)
  }
}
